import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  BillingSupplyAuthorizationProductsTotalizerData,
  BillingSupplyAuthorizationProductsTotalizerResponse,
} from '@/features/supplyAuthorizations/types/billingSupplyAuthorizationProductsTotalizer.type'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

type UseBillingSupplyAuthorizationProductsTotalizerProps = {
  billId?: string
}

type UseBillingSupplyAuthorizationProductsTotalizerType = ({
  billId,
}: UseBillingSupplyAuthorizationProductsTotalizerProps) => UseQueryResult<
  BillingSupplyAuthorizationProductsTotalizerData[],
  unknown
>

export const useBillingSupplyAuthorizationProductsTotalizer: UseBillingSupplyAuthorizationProductsTotalizerType = ({
  billId,
}) => {
  const privateAxios = usePrivateAxios()

  return useQuery<
    BillingSupplyAuthorizationProductsTotalizerResponse,
    unknown,
    BillingSupplyAuthorizationProductsTotalizerData[]
  >({
    queryKey: ['billingSupplyAuthorizationProductsTotalizer', billId],
    queryFn: () => {
      return privateAxios.get(`/billing/supply_authorizations/${billId}/products_totalizer`)
    },
    enabled: !!billId,
    select: (data) => data?.data?.data,
  })
}
